import { InjectionToken } from '@angular/core';
import {
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { ProspettoDto } from '@ideapa/common-dto';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'moltiplicatore';
export const ENTITY_PLURAL = 'moltiplicatori';
export const gridColumns: (prospetti: ProspettoDto[]) => EntityListField[] = (
  prospetti: ProspettoDto[]
) => {
  return [
    {
      elementLabel: 'Prospetto',
      filterType: FilterType.enum,
      fieldType: FieldType.enum,
      field: 'strutturaProspetto.prospetto.descrizione',
      sortable: true,
      sort: 'asc',
      elementValues: prospetti
        // .filter(
        //   (p) => p.codice === '04' || p.codice === '05' || p.codice === '06'
        // )
        .sort((c1, c2) => {
          return c1.codice > c2.codice ? 1 : -1;
        })
        .map((p) => ({
          description: p.descrizione,
          value: p.descrizione,
        })),
      minWidth: 300,
    },
    {
      elementLabel: 'Lettera',
      filterType: FilterType.text,
      fieldType: FieldType.text,
      field: 'strutturaProspetto.lettera',
      sortable: true,
      sort: 'asc',
      maxWidth: 100,
    },
    {
      elementLabel: 'Rif 1',
      filterType: FilterType.text,
      fieldType: FieldType.text,
      field: 'strutturaProspetto.rif1',
      maxWidth: 80,
    },
    {
      elementLabel: 'Rif 2',
      filterType: FilterType.text,
      fieldType: FieldType.text,
      field: 'strutturaProspetto.rif2',
      maxWidth: 80,
    },
    {
      elementLabel: 'Rif 3',
      filterType: FilterType.text,
      fieldType: FieldType.text,
      field: 'strutturaProspetto.rif3',
      maxWidth: 80,
    },
    {
      elementLabel: 'Descrizione',
      filterType: FilterType.text,
      fieldType: FieldType.text,
      field: 'strutturaProspetto.descrizione',
      sortable: true,
    },
    {
      elementLabel: 'Dare',
      filterType: FilterType.number,
      fieldType: FieldType.integer,
      field: 'moltiplicatoreDare',
      sortable: true,
      maxWidth: 80,
    },
    {
      elementLabel: 'Avere',
      filterType: FilterType.number,
      fieldType: FieldType.integer,
      field: 'moltiplicatoreAvere',
      sortable: true,
      maxWidth: 80,
    },
  ];
};
export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
